'use strict';
import {module} from '../app';

module.directive('autoDigest', [function () {
  return {
    restrict: 'A',
    link: function (scope, el, attrs) {
      let timerId = setInterval(function () {
        if (!scope.$$phase)
          scope.$digest();
      }, 200);

      scope.$on('$destroy', function () {
        clearInterval(timerId);
      });
    }
  };
}]);



// WEBPACK FOOTER //
// ./src/scripts/directives/autoDigest.js